
import { useState, useRef } from 'react';
import Image from 'next/image';

const ContentCard = ({
	imageSrc,
	altText,
	imageWidth,
	imageHeight,
	title,
	description,
	listItems,
	buttonText = 'Know More',
}) => {
	const [showText, setShowText] = useState(false);
	const [showLabel, setShowLabel] = useState(true);
	const [isClicked, setIsClicked] = useState(false);
	const timeoutRef = useRef<NodeJS.Timeout | null>(null); 

	const handleButtonClick = () => {
		if (isClicked) {
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current);
				timeoutRef.current = null;
			}
			setShowText(false);
			setShowLabel(true);
			setIsClicked(false);
		} else {
			// Update states and start a timeout
			setShowText(true);
			setIsClicked(true);
			setShowLabel(false);
			timeoutRef.current = setTimeout(() => {
				setShowText(false);
				setShowLabel(true);
				setIsClicked(false);
			}, 15000);
		}
	};

	return (
		<div className="relative mb-10 ml-7 mr-7 flex flex-col items-center">
			<div className="mb-4">
				<Image
					src={imageSrc}
					alt={altText}
					width={imageWidth}
					height={imageHeight}
					className={`rounded-3xl ${showText ? 'opacity-30' : ''}`}
				/>
				{showText && (
					<div
						className="absolute inset-0 flex flex-col items-center justify-center"
						style={{
							animation: `fadeIn 0.6s ease-in-out forwards`,
						}}
					>
						<h1 className="mb-2 pl-5 pr-5 text-left text-2xl font-bold leading-tight text-black backdrop-blur-md backdrop-filter dark:text-white sm:text-3xl sm:leading-tight">
							{title.toUpperCase()}
						</h1>
						<p className="pl-5 pr-5 text-left text-2xl font-medium leading-tight text-black backdrop-blur-md backdrop-filter dark:text-white sm:text-xl sm:leading-tight">
							{description}
							<ul className="list-disc pl-6 text-left">
								{listItems.map((item, index) => (
									<li key={index}>{item}</li>
								))}
							</ul>
						</p>
					</div>
				)}
				{showLabel && (
					<div className="absolute top-0 left-0">
						<div
							className="rounded-md bg-white bg-opacity-30 p-2 backdrop-blur-md backdrop-filter"
							style={{
								animation: `fadeIn 0.6s ease-in-out forwards`,
								display: 'inline-block', // Wrap tightly around the text
								...(title.includes('-') && { maxWidth: '100%' }), // Apply maxWidth only for titles with '-'
							}}
						>
							{title.includes('-') ? (
								<>
									<h2 className="text-3xl font-bold text-black dark:text-white text-left">
										{title.split('-')[0].toUpperCase()}
									</h2>
									<h2 className="text-3xl font-bold text-black dark:text-white text-left">
										{title.split('-')[1].toUpperCase()}
									</h2>
								</>
							) : (
								<h2
									className="text-3xl font-bold text-black dark:text-white text-left break-words"
									style={{
										wordBreak: 'break-word',
										whiteSpace: 'normal',
									}}
								>
									{title.toUpperCase()}
								</h2>
							)}
						</div>
					</div>

				)}
			</div>
			<div className="text-center">
				<button
					onClick={handleButtonClick}
					onMouseEnter={(e) => {
						if (!isClicked) {
							e.currentTarget.style.transform = 'translateY(-5px)';
							e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';
						}
					}}
					onMouseLeave={(e) => {
						e.currentTarget.style.transform = 'translateY(0)';
						e.currentTarget.style.boxShadow = '0 0 0 rgba(0, 0, 0, 0)';
					}}
					style={{
						transition: 'transform 0.3s ease, box-shadow 0.3s ease',
						transform: 'translateY(0)',
						boxShadow: '0 0 0 rgba(0, 0, 0, 0)',
						backgroundColor: isClicked ? 'grey' : 'rgb(59 130 246)', // bg-blue-500
						color: 'white',
						borderRadius: '1.5rem', // rounded-3xl
						padding: '0.5rem 1rem', // py-2 px-4
					}}
				>
					{buttonText}
				</button>
			</div>
		</div>
	);
};

export default ContentCard;

